import React, { PureComponent, Fragment } from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
//import { Modal, Form, Input } from 'antd';
import {
  Input,
  Tooltip,
  Cascader,
  Select,
  Row,
  Col,
  Checkbox,
  Button,
  message,
  AutoComplete,
  Modal,
} from 'antd';
import { connect } from 'dva';

@connect(({ user, login }) => ({
  currentUser: user.currentUser,
  login,
  loading: login.loading,
}))
class ForcePasswordModal extends PureComponent {
  state = {
    visible: true,
  };

  hideModal = () => {
    this.setState({
      visible: false,
    });
  };

  // handleOk = e => {
  //   alert("click ok")

  //   const { dispatch } = this.props;
  //   dispatch({
  //     type: 'login/forceChangePassowrd',
  //     payload: {

  //     },
  //   });

  //   this.setState({
  //     visible: false,
  //   });
  // };
  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('password')) {
      callback('Two passwords that you enter are not same!');
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  currentPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (this.props.login.pass && this.props.login.pass !== form.getFieldValue('oldPass')) {
      callback('Please enter correct password');
    }
    callback();
  };
  handleSubmit = e => {
    e.preventDefault();
    const { dispatch } = this.props;

    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        await dispatch({
          type: 'login/forceChangePassowrd',
          payload: {
            oldPass: values.oldPass,
            newPass: values.password,
          },
        });
        this.setState({
          visible: false,
        });
      }
    });
  };
  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 11,
        },
        sm: {
          span: 16,
          offset: 11,
        },
      },
    };

    return (
      this.props.currentUser &&
      this.props.currentUser.Role === 'CHILD_USER' &&
      this.props.currentUser.ChangeAutoGeneratePassword === false && (
        <Modal onOk={this.handleOk} closable={false} visible={true} footer={null} header={null}>
          <Fragment>
            <div style={{ paddingTop: 37, marginLeft: '35%', marginBottom: '26px' }}>
              <h5> Change Password </h5>
            </div>
            <Form {...formItemLayout} onSubmit={this.handleSubmit} hideRequiredMark>
              <Form.Item label="Current password">
                {getFieldDecorator('oldPass', {
                  rules: [
                    {
                      // required: true,
                      // message: 'Please enter your current password!',
                    },
                    {
                      validator: this.currentPassword,
                    },
                  ],
                })(
                  <Input.Password
                    style={{ width: '300px' }}
                    // placeholder="Current Password"
                    // prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  />
                )}
              </Form.Item>
              <Form.Item label="New password" hasFeedback>
                {getFieldDecorator('password', {
                  rules: [
                    {
                      required: true,
                      message: 'Please input your password!',
                    },
                    {
                      validator: this.validateToNextPassword,
                    },
                  ],
                })(<Input.Password style={{ width: '300px' }} />)}
              </Form.Item>
              <Form.Item label="Retype new password" hasFeedback>
                {getFieldDecorator('confirm', {
                  rules: [
                    {
                      required: true,
                      message: 'Please confirm your password!',
                    },
                    {
                      validator: this.compareToFirstPassword,
                    },
                  ],
                })(<Input.Password style={{ width: '300px' }} onBlur={this.handleConfirmBlur} />)}
              </Form.Item>

              <Form.Item {...tailFormItemLayout}>
                <Button loading={this.props.loading} type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Fragment>
        </Modal>
      )
    );
  }
}
const WrappedRegistrationForm = Form.create({ name: 'register' })(ForcePasswordModal);

export default WrappedRegistrationForm;
